document.addEventListener( 'DOMContentLoaded', function () {
  
  window.addEventListener('click',function(e){
    var current = e.target;
    if (current.classList.contains('video-container__play-btn')) {
      e.preventDefault();
      var video_container = current.closest('.section--video-custom').querySelector('.video_container');
      if (video_container.hasAttribute('data-media-id') && !video_container.querySelector('iframe')) {
        var video_id = video_container.getAttribute('data-media-id');
        var video_type = video_container.getAttribute('data-type');
        var video_loop = video_container.getAttribute('data-loop');
  
        var video_iframe = document.createElement('iframe');
        if (video_type == "youtube") {
          video_iframe.setAttribute('src', 'https://www.youtube.com/embed/' + video_id + '?enablejsapi=1&autoplay=1' + video_loop);
          video_iframe.classList.add('js-youtube');
        } else {
          var vimeo_script_url = 'https://player.vimeo.com/api/player.js';
          var vimeo_player_script = document.createElement('script');
          vimeo_player_script.setAttribute('src',vimeo_script_url);
          document.querySelector('head').append(vimeo_player_script);

          video_iframe.setAttribute('src', 'https://player.vimeo.com/video/' + video_id + '?autoplay=1' + video_loop);
          video_iframe.classList.add('js-vimeo');
        }
        video_iframe.classList.add('section--video-custom__video');
        video_iframe.setAttribute('allow','autoplay;encrypted-media');
        video_iframe.setAttribute('allowfullscreen',true);
        video_container.append(video_iframe);
      }
      
      video_container.closest('.popup-bg').classList.add('open');
      var video_tag = current.closest('.section--video-custom').querySelector('.popup-bg .video_container video');
      if (video_tag) {
        video_tag.play();
      }
    }
    if (current.classList.contains('popup__close')) {
      current.closest('.popup-bg').classList.remove('open');
      if (current.closest('.section--video-custom') && current.closest('.section--video-custom').querySelector('.js-youtube')) {
        var this_video = current.closest('.section--video-custom').querySelector('.js-youtube').contentWindow;
        this_video.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          "*"
        );
      }
      if (current.closest('.section--video-custom') && current.closest('.section--video-custom').querySelector('.js-vimeo')) {
        var this_video = current.closest('.section--video-custom').querySelector('.js-vimeo');
        var vimeo_player = new Vimeo.Player(this_video);
        vimeo_player.pause();
      }
      if (current.closest('.section--video-custom') && current.closest('.section--video-custom').querySelector('video')) {
        var this_video = current.closest('.section--video-custom').querySelector('video');
        this_video.pause();
      }
    }
  });

  function megamenu_tab_switcher(e) {
    if (e.target.classList.contains('maga-menu__tab-link')) {
      if (!e.target.classList.contains('active')) {
        var tab_handle = e.target.getAttribute('data-handle');

        // Scope to the mega menu that was clicked, so we don't toggle
        // panels/tabs belonging to other mega menus on the page.
        var scope = e.target.closest('.megamenu-tabs') || document;

        var active_tab = scope.querySelector('.maga-menu__tab-link.active');
        if (active_tab) active_tab.classList.remove('active');
        e.target.classList.add('active');

        var active_panel = scope.querySelector('.submenu-tab-content.active');
        if (active_panel) active_panel.classList.remove('active');

        var target_panel = scope.querySelector('.submenu-tab-content[data-handle="' + tab_handle + '"]');
        if (target_panel) target_panel.classList.add('active');
      }
    }
  }
  window.addEventListener('click',megamenu_tab_switcher);
  
  function sticky_media_position_top(e) {
    if (document.querySelector('.product__column-sticky')) {
      let currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      if (currentScroll > lastScrollTop) {
        if (document.querySelector('.product__column-sticky').classList.contains('product__column-sticky--scroll-top')) {
          document.querySelector('.product__column-sticky').classList.remove('product__column-sticky--scroll-top');
        }
      } else {
        if (!document.querySelector('.product__column-sticky').classList.contains('product__column-sticky--scroll-top')) {
          document.querySelector('.product__column-sticky').classList.add('product__column-sticky--scroll-top');
        }
      }
      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    }
  }
  let lastScrollTop = 0;
  window.addEventListener('scroll',sticky_media_position_top);


  /* ADD VOUCHERS */
  /*const voucher_ID = '46396120596724';
  function addVoucherToCart(quantity,main_product_id,child_product_ID) {
    console.log('quantity',quantity);
    console.log('main_product_id',main_product_id);
    console.log('child_product_ID',child_product_ID);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: child_product_ID,
        quantity: quantity,
        properties: {
          _for_variant: main_product_id
        }
      })
    })
    .then(response => response.json())
    .then(data => {
      getCart()
      .then(cart => {
        console.log(cart.items);
      });
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }

  function checkCartForVouchers(quantity,main_product_id) {
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const hasVoucherItem = cart.items.some(item => 
        item.properties && item.properties.Vouchers === 'Yes'
      );
      if (hasVoucherItem) {
        addVoucherToCart(quantity,main_product_id,voucher_ID);
      }
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }

  function handleAddToCart(e) {
    if (e.target.classList.contains('product-form__submit')) {
      const form = e.target.closest('form[action="/cart/add"]');
      if (!form) return;

      // main data
      const quantityInput = document.querySelector('quantity-input input[name="quantity"]');
      const quantity = quantityInput ? parseInt(quantityInput.value) : 1;
      const product_id_input = form.querySelector('input[name="id"]');
      const main_product_id = product_id_input ? product_id_input.value : '';

      // voucher fee
      const voucherCheckbox = document.querySelector('input[name="vouchers_needed"]:checked');
      const isVoucherSelected = voucherCheckbox && voucherCheckbox.value == 'voucher';

      if (isVoucherSelected) {
        addVoucherToCart(quantity,main_product_id,voucher_ID);
      }

      // color fee
      var need_customization_input = document.querySelector('[name="need_customization"]:checked');
      if (need_customization_input && need_customization_input.value == "Yes") {
        console.log(need_customization_input.value);
        var need_logo_input = document.querySelector('[name="properties[Need logo?]"]:checked');
        if (need_logo_input && need_logo_input.value == "Yes") {
          var number_of_colors_input = document.querySelector('[name="properties[# of Colors in logo]"]');
          if (number_of_colors_input) {
            var number_of_colors = number_of_colors_input.value;
            console.log('Number of colors:',number_of_colors);
            console.log('quantity:',quantity);
            
            getProductVariants('logo-set-up-fee')
            .then(variants => {
              variants.forEach((variant) => {
                if (Number(variant.title) == Number(number_of_colors)) {
                  addVoucherToCart(quantity,main_product_id,variant.id);
                }
              });
            });
          }
        }
      }
    }
  }
  window.addEventListener('click',handleAddToCart);

  function getCart() {
    return fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      return cart;
    });
  }

  function getProductVariants(productHandle) {
    return fetch('/products/' + productHandle + '.js')
      .then(response => response.json())
      .then(product => {
        console.log('Variants:', product.variants);
        return product.variants;
      })
      .catch(error => {
        console.error('Error:', error);
        throw error;
      });
  }*/
  
});

/*const voucherId = 46396120596724;
const voucherValue = 'Yes';
const originalFetch = window.fetch;

window.fetch = async function(...args) {
  const response = await originalFetch.apply(this, args);  
  if (typeof args[0] === 'string' && args[0].includes('/cart/') && 
      !args[0].includes('/cart.js') && 
      !args[0].includes('/cart/add.js') && 
      !args[0].includes('/cart/update.js')) {
    setTimeout(syncCart, 300);
  } 
  return response;
}

const syncCart = async () => {
  try {
    const cart = await (await fetch('/cart.js')).json();
    
    const itemsNeedingVouchers = cart.items.filter(i => i.properties?.Vouchers === 'Yes');
    const vouchers = cart.items.filter(i => i.variant_id === voucherId);
    
    for (const item of itemsNeedingVouchers) {
      const voucher = vouchers.find(v => v.properties?.LinkedProduct === item.key);
      
      if (!voucher) {
        await addVoucher(item);
      } else if (voucher.quantity !== item.quantity) {
        await updateCartItem(voucher.id, item.quantity);
      }
    }
    
    const updatedCart = await (await fetch('/cart.js')).json();
    const updatedVouchers = updatedCart.items.filter(i => i.variant_id === voucherId);
    
    for (const voucher of updatedVouchers) {
      const mainItemExists = updatedCart.items.some(i => 
        i.key === voucher.properties?.LinkedProduct && 
        i.properties?.Vouchers === 'Yes'
      );
      
      if (!mainItemExists) {
        await updateCartItem(cart.items, 0);
      }
    }

    
  } catch (error) {
    console.error('Error in syncCart:', error);
  }
}

const addVoucher = async (product) => {
  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [{
        id: voucherId,
        quantity: product.quantity,
        properties: {
          LinkedProduct: product.key,
          ForProduct: product.title
        }
      }]
    })
  })
  await fetch('/cart.js').then(res => res.json())
}

const updateCartItem = async (id, quantity) => {
  await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates: { [id]: quantity } })
  }).then((response) => {
    return response.text();
  }).then((responseText) => {
    
  })
  await fetch('/cart.js').then(res => res.json())
}

document.body.addEventListener('click', (event) => {
  if (event.target.closest('[name="add"], .quantity__button, cart-remove-button')) {
    console.log(event)
    setTimeout(syncCart, 300);
  }
})

document.addEventListener('DOMContentLoaded', syncCart)*/
/*subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
  setTimeout(syncCart, 300);
})*/